import { TrainIdentifier } from "@vygruppen/vy-train-map";
import constate from "constate";
import { DirectionEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import {
  getRepresentativeTrainId,
  toTrainSerie,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/utils";
import { useTrainRoutes } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoutes";
import { getDirection } from "features/VehicleSidebar/AffectedTrains/utils/utils";
import { useState } from "react";

function useTrainInfo() {
  const [allTrainIds, setAllTrainIds] = useState<TrainIdentifier[]>([]);
  const res = useTrainRoutes(allTrainIds);
  /**
   * use 'useTrainRouteBatch' instead, as it doesnt require
   * representativeTrainId to work, just a trainId of the same serie.
   */
  const _useTrainRouteBatch = (representativeTrainId: TrainIdentifier) => {
    if (!representativeTrainId) {
      return { ...res, data: undefined };
    }
    return {
      ...res,
      data: res?.data?.(representativeTrainId),
    };
  };
  const useTrainRouteBatchBySerie = (
    trainSerie: string,
    direction: DirectionEnum,
  ) => {
    const representativeTrainId = getRepresentativeTrainId(
      allTrainIds,
      trainSerie,
      direction,
    );
    return _useTrainRouteBatch(representativeTrainId);
  };
  const useTrainRouteBatch = (trainId: TrainIdentifier) => {
    const trainSerie = toTrainSerie(trainId.identifier);
    const direction = getDirection(trainId);
    return useTrainRouteBatchBySerie(trainSerie, direction);
  };
  return { useTrainRouteBatchBySerie, useTrainRouteBatch, setAllTrainIds };
}

const [TrainInfoProvider, useTrainInfoContext] = constate(useTrainInfo);

export { TrainInfoProvider, useTrainInfoContext };
